import React from "react";
import { footerLinks } from "../../constants/footerLinks";
import { Link } from "react-router-dom";
import LogoColor from "../../assets/img/logo-color.png";
import { useSelector } from "react-redux";

function Footer() {

  const { user } = useSelector((state) => state.user);
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mx-auto max-w-screen-2xl px-4 sm:px-10 py-4" >
        <div className="flex flex-row justify-between items-center">
          <div className=" col-span-1 border-gray-200 py-1 flex items-center justify-center bg-white pr-20">
            <div className="mr-3">
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="flex-shrink-0 h-4 w-4 text-brand-600"
                aria-hidden="true"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" y="3" width="15" height="13"></rect>
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                <circle cx="18.5" cy="18.5" r="2.5"></circle>
              </svg>
            </div>
            <div className="">
              <span className="block text-sm font-normal leading-5">
              Delivery all over Nepal
              </span>
            </div>
          </div>
          <div className=" col-span-1 border-gray-200 py-1 flex items-center justify-center bg-white  pr-20">
            <div className="mr-3">
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="flex-shrink-0 h-4 w-4 text-brand-600"
                aria-hidden="true"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div className="">
              <span className="block text-sm font-normal leading-5">
                Support 24/7 At Anytime
              </span>
            </div>
          </div>
          <div className=" col-span-1 border-gray-200 py-1 flex items-center justify-center bg-white">
            <div className="mr-3">
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="flex-shrink-0 h-4 w-4 text-brand-600"
                aria-hidden="true"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                <line x1="1" y1="10" x2="23" y2="10"></line>
              </svg>
            </div>
            <div className="">
              <span className="block  text-sm font-normal leading-5">
                Secure Payment Totally Safe
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-line mt-0" />

      <div className="pb-16 lg:pb-0 xl-pb-0 bg-white">
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
          {user ?
            <div className="grid grid-cols-2 md:grid-cols-7 xl:grid-cols-12 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 py-10 lg:py-16 justify-between ">
              {footerLinks.map((data, index) => {
                return (
                  <div
                    key={index}
                    className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3"
                  >
                    <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                      {data.titleHeader}
                    </h3>
                    <ul className="text-sm flex flex-col space-y-3" key={index}>
                      {data.title.map((title, index) => {
                        return (
                          <li key={index} className="flex items-baseline">
                            <Link
                              className="!text-gray-600 inline-block w-full !no-underline hover:!text-brand-600"
                              to={title.href}
                            >
                              {title.Name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
              <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
                <p className="text-base leading-7 font-medium block">
                  Call Us Today!
                </p>
                <h5 className="text-2xl font-bold text-brand-600 leading-7">
                +977-9851448066
                </h5>
              </div>
              <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
                <Link to="/">
                  <span
                    style={{
                      boxSizing: "border-box",
                      display: "inline-block",
                      overflow: "hidden",
                      width: "initial",
                      height: "initial",
                      background: "none",
                      opacity: "1",
                      border: "0",
                      margin: "0",
                      padding: "0",
                      position: "relative",
                      maxWidth: "100%",
                    }}
                  >
                    <img className=" w-48" src={LogoColor} />
                  </span>
                </Link>
                <p className="leading-7 font-sans text-sm text-gray-600 mt-3">
                  <span>
                    O2, Newroad, Kathmandu-22, Nepal
                  </span>
                  <br />
                  <span>Tel: +977-1-5927066</span>
                  <br />
                  <span>Email: info@wholesaledai.com</span>
                </p>
              </div>
            </div>
            : 
            <div className="flex flex-row justify-between items-center">
              <div className="">
                <Link to="/">
                  <span
                    style={{
                      boxSizing: "border-box",
                      display: "inline-block",
                      overflow: "hidden",
                      width: "initial",
                      height: "initial",
                      background: "none",
                      opacity: "1",
                      border: "0",
                      margin: "0",
                      padding: "0",
                      position: "relative",
                      maxWidth: "100%",
                    }}
                  >
                    <img className=" w-48" src={LogoColor} />
                  </span>
                </Link>
                <p className="leading-7 font-sans text-sm text-gray-600 mt-3">
                  <span>
                    O2, Newroad, Kathmandu-22, Nepal
                  </span>
                  <br />
                  <span>Tel: +977-1-5927066</span>
                  <br />
                  <span>Email: info@wholesaledai.com</span>
                </p>
              </div>
              <div className="">
                <p className="text-base leading-7 font-medium block">
                  Call Us Today!
                </p>
                <h5 className="text-2xl font-bold text-brand-600 leading-7">
                  <a href="tel:+9779851448066" className="text-brand-600">+977-9851448066</a>
                  
                </h5>
              </div>

            </div>}
          <hr className="hr-line" />

        </div>
        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10 flex justify-center py-4">
          <p className="text-sm text-gray-500 leading-6">
            Copyright {new Date().getFullYear()} @
            <span className="text-brand-600">Wholesale Dai</span>, All rights
            reserved.
          </p>
        </div>
      </div>

    </div>
  );
}

export default Footer;
